module.exports = __webpack_public_path__ + "img/logo_line.046a6faf.png";